import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import PrintIcon from "@mui/icons-material/Print";

const PaySlip = ({ navigation, onCancel, date, employeeId }) => {
  const handleCancleClick = () => {
    onCancel();
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Ensures 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const [message, setMessage] = useState({});
  const [empData, setEmpData] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchSalaryDetails = () => {
    const formattedDate = date
      .toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
      })
      .replace("/", "/");
    setLoading(true);
    fetch(`https://trading.zarpsoftware.in/jps/Jpserp/getSalaryData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        empId: employeeId,
        month: formattedDate,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setMessage(data.message || {});
        setEmpData(data.empData || {});
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching Salary Details data:", error);
      });
  };

  useEffect(() => {
    console.log("hiiiii i am in useEffect.....");
    fetchSalaryDetails();
  }, []);

  console.log("message : ", message);
  console.log("employee data : ", empData);

  const handlePrint = () => {
    // Store the current document title
    const originalTitle = document.title;
    
    // Change the document title for the print job
    document.title = `Payslip_${employeeId}_${date.toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    })}`;
    
    // Create a new window for printing
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    
    // Create printable content
    const printableContent = `
      <html>
        <head>
          <title>${document.title}</title>
          <style>
            ${Object.entries(styles).map(([key, value]) => {
              if (typeof value === 'object') {
                return `.${key} { ${Object.entries(value).map(([k, v]) => `${k.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${v};`).join(' ')} }`;
              }
              return '';
            }).join('\n')}
            body {
              font-family: Arial, sans-serif;
              padding: 10px;
              background-color: white;
              color: #333;
              margin: 0;
            }
            .payslip-container {
              max-width: 800px;
              margin: 0 auto;
              padding: 15px;
              background-color: #f5faff;
              border-radius: 8px;
            }
            .row {
              display: flex;
              justify-content: space-between;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 10px;
            }
            th, td {
              padding: 8px;
              text-align: left;
              border-bottom: 1px solid #ddd;
            }
            th {
              border-bottom: 2px solid #0056b3;
              color: #0056b3;
            }
            .bold {
              font-weight: bold;
            }
            .blue {
              color: #0056b3;
            }
            .section {
              margin-top: 20px;
              padding: 10px;
              background-color: #ffffff;
              border-radius: 6px;
              box-shadow: 0 0 10px rgba(0, 86, 179, 0.2);
            }
            .salary-container {
              display: flex;
              justify-content: space-between;
            }
            .salary-table {
              width: 48%;
            }
            @media print {
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              .section {
                page-break-inside: avoid;
                break-inside: avoid;
              }
              .payslip-container {
                page-break-before: avoid;
                margin: 0;
                padding: 10px;
              }
              table {
                page-break-inside: avoid;
              }
              /* Adjust spacing to better fit on pages */
              .section {
                margin-top: 10px;
                padding: 8px;
              }
              h2, h1, h3 {
                margin-top: 10px;
                margin-bottom: 10px;
              }
            }
          </style>
        </head>
        <body>
          <div class="payslip-container">
            <h2 class="blue">PAYSLIP ${date.toLocaleDateString("en-US", {
              month: "short",
              year: "numeric",
            }).toUpperCase()}</h2>
            <h1>JPS CHEMICALS PRIVATE LIMITED</h1>
            <p>2/10 Shivaji Nagar, Big Bazar Road,<br>Sat Rasta Solapur, Maharashtra - 413001, India</p>
            
            <div class="section">
              <h3 class="blue">${empData.name || 'Employee Name'}</h3>
              <table>
                <tbody>
                  <tr>
                    <td class="blue bold">Employee Number</td>
                    <td>${employeeId || 'N/A'}</td>
                    <td class="blue bold">Date Joined</td>
                    <td>${empData.date_of_joining ? formatDate(empData.date_of_joining) : 'N/A'}</td>
                  </tr>
                  <tr>
                    <td class="blue bold">Department</td>
                    <td>SE Unit</td>
                    <td class="blue bold">Designation</td>
                    <td>${empData.designation || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td class="blue bold">Payment Mode</td>
                    <td>Bank Transfer</td>
                    <td class="blue bold">Bank</td>
                    <td>DCB BANK</td>
                  </tr>
                  <tr>
                    <td class="blue bold">Bank IFSC</td>
                    <td>DCBL0000323</td>
                    <td class="blue bold">Bank Account</td>
                    <td>32311100003681</td>
                  </tr>
                  <tr>
                    <td class="blue bold">PAN</td>
                    <td>ANYPU9492K</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div class="section">
              <h3 class="blue">SALARY DETAILS</h3>
              <table>
                <thead>
                  <tr>
                    <th>Actual Payable Days</th>
                    <th>Total Working Days</th>
                    <th>Loss of Pay Days</th>
                    <th>Days Payable</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>${message.working_days || 'N/A'}</td>
                    <td>${message.total_days || 'N/A'}</td>
                    <td>${message.lossDay || '0'}</td>
                    <td>${message.working_days || 'N/A'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div class="section" style="page-break-before: avoid;">
              <h3 class="blue">EARNINGS & DEDUCTIONS</h3>
              <div class="salary-container">
                <div class="salary-table">
                  <table>
                    <thead>
                      <tr>
                        <th colspan="2">EARNINGS</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Basic</td>
                        <td>${message.salary || 'N/A'}</td>
                      </tr>
                      <tr>
                        <td>HRA</td>
                        <td>16,666.67</td>
                      </tr>
                      <tr>
                        <td>Conveyance Allowance</td>
                        <td>3,000.00</td>
                      </tr>
                      <tr>
                        <td>Medical Allowance</td>
                        <td>3,470.83</td>
                      </tr>
                      <tr>
                        <td>Other Allowances</td>
                        <td>1,749.25</td>
                      </tr>
                      <tr>
                        <td class="blue bold">Gross Salary Earned</td>
                        <td class="blue bold">79,747.34</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                <div class="salary-table">
                  <table>
                    <thead>
                      <tr>
                        <th colspan="2">TAXES & DEDUCTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>PF</td>
                        <td>1000.00</td>
                      </tr>
                      <tr>
                        <td>ESI</td>
                        <td>2000.00</td>
                      </tr>
                      <tr>
                        <td>Professional Tax</td>
                        <td>3000.00</td>
                      </tr>
                      <tr>
                        <td>Loan Recovery</td>
                        <td>200.00</td>
                      </tr>
                      <tr>
                        <td>Income Tax</td>
                        <td>2000.00</td>
                      </tr>
                      <tr>
                        <td class="blue bold">Total Deductions</td>
                        <td class="blue bold">8200.00</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              
              <h3 class="blue" style="margin-top: 20px;">Net Salary Payable (A - B): 76,547</h3>
              <h3>Seventy Six Thousand Five Hundred and Forty Seven</h3>
              <p style="margin-top: 20px;">**NOTE: All amounts displayed in the payslip are in INR</p>
              <p style="text-align: right; margin-top: 85px; font-weight: bold;">Authorized Signature and Stamp</p>
            </div>
          </div>
        </body>
      </html>
    `;
    
    // Write to the new window and trigger print
    printWindow.document.open();
    printWindow.document.write(printableContent);
    printWindow.document.close();
    
    // Wait for content to load before printing
    printWindow.onload = function() {
      printWindow.focus();
      setTimeout(() => {
        printWindow.print();
        // Restore original title
        document.title = originalTitle;
        
        // Add event listener for afterprint
        printWindow.addEventListener('afterprint', function() {
          // Close the print window after printing is done or canceled
          setTimeout(() => {
            printWindow.close();
          }, 1000);
        });
      }, 500); // Increased timeout for better content loading
    };
  };

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="page-content">
          <div className="center-div">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="my-3">
        <div className="px-2 d-flex justify-content-between align-items-center">
          <div className="d-flex">
            <div className="cursor-pointer d-flex justify-content-center align-items-center back-button">
              <ArrowBackIosIcon
                width={2}
                className="arrow-child"
                onClick={handleCancleClick}
              />
            </div>
            <h5
              className="mt-1 mx-2 text-primary"
              style={{ letterSpacing: "1px" }}
            >
              PaySlip
            </h5>
          </div>
          <button
            onClick={handlePrint}
            className="btn btn-primary d-flex align-items-center"
            style={{ gap: '5px' }}
          >
            <PrintIcon fontSize="small" />
            Print
          </button>
        </div>
      </div>
      <div style={styles.container}>
        <h2 style={styles.payslipMonth}>PAYSLIP FEB 2025</h2>
        <h1 style={styles.company}>JPS CHEMICALS PRIVATE LIMITED</h1>
        <p style={styles.address}>
          2/10 Shivaji Nagar, Big Bazar Road,
          <br />
          Sat Rasta Solapur, Maharashtra - 413001, India
        </p>

        <div style={styles.section}>
          <h3 style={styles.employeeName}>{empData.name}</h3>
          <table style={styles.table}>
            <tbody>
              <tr>
                <td style={styles.td1}>Employee Number</td>
                <td style={styles.td}>{employeeId}</td>
                <td style={styles.td1}>Date Joined</td>
                <td style={styles.td}>{formatDate(empData.date_of_joining)}</td>
              </tr>
              <tr>
                <td style={styles.td1}>Department</td>
                <td style={styles.td}>SE Unit</td>
                <td style={styles.td1}>Designation</td>
                <td style={styles.td}>{empData.designation}</td>
              </tr>
              <tr>
                <td style={styles.td1}>Payment Mode</td>
                <td style={styles.td}>Bank Transfer</td>
                <td style={styles.td1}>Bank</td>
                <td style={styles.td}>DCB BANK</td>
              </tr>
              <tr>
                <td style={styles.td1}>Bank IFSC</td>
                <td style={styles.td}>DCBL0000323</td>
                <td style={styles.td1}>Bank Account</td>
                <td style={styles.td}>32311100003681</td>
              </tr>
              <tr>
                <td style={styles.td1}>PAN</td>
                <td style={styles.td}>ANYPU9492K</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>SALARY DETAILS</h3>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Actual Payable Days</th>
                <th style={styles.th}>Total Working Days</th>
                <th style={styles.th}>Loss of Pay Days</th>
                <th style={styles.th}>Days Payable</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.td}>{message.working_days}</td>
                <td style={styles.td}>{message.total_days}</td>
                <td style={styles.td}>{message.lossDay}</td>
                <td style={styles.td}>{message.working_days}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>EARNINGS & DEDUCTIONS</h3>
          <div style={styles.salaryContainer}>
            {/* Earnings Table */}
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th1} colSpan="2">
                    EARNINGS
                  </th>
                </tr>
              </thead>
              <tbody>
                {renderRow("Basic", `${message.salary}`)}
                {renderRow("HRA", "16,666.67")}
                {renderRow("Conveyance Allowance", "3,000.00")}
                {renderRow("Medical Allowance", "3,470.83")}
                {renderRow("Other Allowances", "1,749.25")}
                {renderRow("Gross Salary Earned", "79,747.34", true)}
              </tbody>
            </table>

            {/* Deductions Table */}
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th1} colSpan="2">
                    TAXES & DEDUCTIONS
                  </th>
                </tr>
              </thead>
              <tbody>
                {renderRow("PF", "1000.00")}
                {renderRow("ESI", "2000.00")}
                {renderRow("Professional Tax", "3000.00")}
                {renderRow("Loan Recovery", "200.00")}
                {renderRow("Income Tax", "2000.00")}
                {renderRow("Total Deductions", "8200.00", true)}
              </tbody>
            </table>
          </div>

          {/* Net Salary */}
          <h3 style={styles.netSalary}>Net Salary Payable (A - B): 76,547</h3>
          <h3 style={styles.netSalaryWords}>
            Seventy Six Thousand Five Hundred and Forty Seven
          </h3>
          <h1 style={styles.Words}>
            **NOTE:All amounts displayed in the payslip are in INR
          </h1>
          <h1 style={styles.stamp}>Authorized Signature and Stamp</h1>
        </div>
      </div>
    </>
  );
};

const renderRow = (label, value, isBold = false) => (
  <tr>
    <td style={isBold ? styles.td1 : styles.td}>{label}</td>
    <td style={isBold ? styles.td1 : styles.td}>{value}</td>
  </tr>
);

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    padding: "20px",
    maxWidth: "800px",
    margin: "0 auto",
    borderRadius: "8px",
    backgroundColor: "#f5faff",
    color: "#333",
  },
  payslipMonth: {
    textAlign: "left",
    color: "#0056b3",
  },
  company: {
    textAlign: "left",
    fontSize: "20px",
    fontWeight: "bold",
  },
  address: {
    textAlign: "left",
    fontSize: "17px",
  },
  section: {
    marginTop: "20px",
    padding: "10px",
    borderRadius: "6px",
    backgroundColor: "#ffffff",
    boxShadow: "0 0 10px rgba(0, 86, 179, 0.2)",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#0056b3",
    borderBottom: "2px solid #0056b3",
    paddingBottom: "5px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px",
  },
  th: {
    borderBottom: "2px solid #0056b3",
    padding: "8px",
    textAlign: "left",
    color: "#0056b3",
  },
  th1: {
    borderBottom: "2px solid #0056b3",
    padding: "8px",
    fontSize: "20px",
    textAlign: "left",
    color: "#0056b3",
  },
  td: {
    padding: "8px",
    borderBottom: "1px solid #ddd",
    color: "#000000",
  },
  td1: {
    padding: "8px",
    borderBottom: "1px solid #ddd",
    color: "#0056b3",
    fontWeight: "bold",
  },
  salaryContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  earnings: {
    width: "48%",
    padding: "10px",
    fontSize: "16px",
  },
  deductions: {
    width: "48%",
    padding: "10px",
    fontSize: "16px",
  },
  subTitle: {
    fontWeight: "bold",
    color: "#0056b3",
    fontSize: "18px",
    borderBottom: "2px solid #0056b3",
    paddingBottom: "5px",
  },
  total: {
    fontWeight: "bold",
    fontSize: "18px",
  },
  netSalary: {
    fontSize: "18px",
    // fontWeight: 'bold',
    color: "#0056b3",
    textAlign: "left",
    marginTop: "20px",
  },
  netSalaryWords: {
    // fontWeight: 'bold',
    fontSize: "18px",
    textAlign: "left",
  },
  Words: {
    fontSize: "15px",
    textAlign: "left",
  },
  stamp: {
    fontWeight: "bold",
    marginTop: "85px",
    fontSize: "15px",
    textAlign: "right",
  },
};

export default PaySlip;